import React from 'react';
import { linearScale } from './functions/LinearScale';
import styles from './css/fillStyle.module.css';

const DEFAULT_EPOCH_DURATION_SECONDS = 30;
const BOX_WIDTH = 120;
const LINE_HEIGHT = 14; //行距
const BOX_PADDING_TOP = 20;
const BOX_PADDING_SIDE = 5;
const FONT_SIZE = 16; // 字體大小
const BOX_OFFSET_TOP = 60; // 方格距離頂部的偏移量（往下移）

// 每個 annotation: { epoch (0-indexed), index (0~1，epoch 內的比例), lines: string[] }
const fixedAnnotationsData = {
  // 範例：psgFileId 10
  5: [
    { epoch: 2 - 1, index: 0.82, lines: ['張開眼睛，', '直視前方', '30秒'] },
    { epoch: 4 - 1, index: 0.02, lines: ['閉上眼睛-', '持續30秒'] },
    { epoch: 5 - 1, index: 0.05, lines: ['眼球看右邊/', '左邊/右邊/左邊'] },
    { epoch: 6 - 1, index: 0.12, lines: ['眼球看上/', '下/上/下'] },
    { epoch: 7 - 1, index: 0.14, lines: ['慢慢眨眼5次'] },
    { epoch: 7 - 1, index: 0.72, lines: ['慢慢咬動牙齒/', '磨牙齒-持續5秒'] },
    { epoch: 9 - 1, index: 0.085, lines: ['模擬打呼', '的聲音3聲'] },
    { epoch: 9 - 1, index: 0.935, lines: ['扭動你的', '右腳3下/', '左腳3下'] },
    { epoch: 11 - 1, index: 0.39, lines: ['用鼻子深呼吸'] },
    { epoch: 12 - 1, index: 0.35, lines: ['用嘴巴深呼吸'] },
    { epoch: 13 - 1, index: 0.55, lines: ['憋住呼吸', '10秒鐘'] },
    { epoch: 14 - 1, index: 0.35, lines: ['回復正常', '呼吸'] },
    { epoch: 14 - 1, index: 0.75, lines: ['確認血氧/', '脈搏數值'] },
    { epoch: 25 - 1, index: 0.21, lines: ['Light Off', 'TCCO2: 51.3'] }
  ],
};

function FixedAnnotationLayer(props) {
  if (!props.psgFileId) return <svg width={props.width} height={props.height} className={styles.fill} />;

  const annotations = fixedAnnotationsData[props.psgFileId];
  if (!annotations || annotations.length === 0) return <svg width={props.width} height={props.height} className={styles.fill} />;

  const canRender =
    typeof props.viewStartTimeSeconds === 'number' && !isNaN(props.viewStartTimeSeconds) &&
    typeof props.viewDurationSeconds === 'number' && !isNaN(props.viewDurationSeconds) && props.viewDurationSeconds > 0;

  if (!canRender) return <svg width={props.width} height={props.height} className={styles.fill} />;

  const transform = linearScale(0, 1, props.leftBoundary, props.rightBoundary);
  const epochDuration = props.epochDurationSeconds || DEFAULT_EPOCH_DURATION_SECONDS;
  const viewStart = props.viewStartTimeSeconds;
  const viewEnd = viewStart + props.viewDurationSeconds;

  const elements = annotations.map((ann, idx) => {
    const absoluteTime = ann.epoch * epochDuration + ann.index * epochDuration;
    if (absoluteTime < viewStart || absoluteTime > viewEnd) return null;

    const proportion = (absoluteTime - viewStart) / props.viewDurationSeconds;
    const x = transform(proportion);
    if (isNaN(x)) return null;

    const boxHeight = BOX_PADDING_TOP + ann.lines.length * LINE_HEIGHT + 4;
    const y = props.topBoundary + BOX_OFFSET_TOP;

    return (
      <g key={`fanno_${props.psgFileId}_${idx}`}>
        <line
          x1={x} y1={y + boxHeight}
          x2={x} y2={props.bottomBoundary}
          // stroke="#4caf50"
          strokeWidth={1.5}
          strokeDasharray="5,3"
        />
        <rect
          x={x}
          y={y}
          width={BOX_WIDTH}
          height={boxHeight}
          fill="#c8e6c9"
          stroke="#4caf50"
          strokeWidth={1.5}
          rx={4}
          fillOpacity={0.93}
        />
        {ann.lines.map((line, i) => (
          <text
            key={i}
            x={x + BOX_PADDING_SIDE}
            y={y + BOX_PADDING_TOP + i * LINE_HEIGHT}
            fontSize={FONT_SIZE}
            fill="#1b5e20"
            fontFamily="sans-serif"
          >
            {line}
          </text>
        ))}
      </g>
    );
  });

  return (
    <svg
      width={props.width}
      height={props.height}
      className={styles.fill}
      style={{ pointerEvents: 'none' }}
    >
      {elements}
    </svg>
  );
}

FixedAnnotationLayer.defaultProps = {
  leftBoundary: 0,
  rightBoundary: 0,
  topBoundary: 0,
  bottomBoundary: 0,
  width: 0,
  height: 0,
};

export default FixedAnnotationLayer;
